import { BRAND_LIST, COUNTRY } from "@type/index";
import UQAUCountryENV from "../country/UQ/AU";
import UQCACountryENV from "../country/UQ/CA";
import UQIDCountryENV from "../country/UQ/ID";
import UQINCountryENV from "../country/UQ/IN";
import UQMYCountryENV from "../country/UQ/MY";
import UQPHCountryENV from "../country/UQ/PH";
import UQSGCountryENV from "../country/UQ/SG";
import UQTHCountryENV from "../country/UQ/TH";
import UQVNCountryENV from "../country/UQ/VN";

export const REACT_APP_BRAND_NAME = process.env.REACT_APP_BRAND_NAME || "";
export const BUILD_VERSION = process.env.BUILD_VERSION || "";
export const LOCALISATION_VERSION = process.env.LOCALISATION_VERSION || "";
export const UQ_UIKIT_VERSION = process.env.UQ_UIKIT_VERSION || "";

// Native app
export const FR_UserAgent = "FRNativeApp";
export const MINIMUM_FETCH_INTERVAL = 15 * 60 * 1000; // 15m
export const FETCH_TIMEOUT_MILLIS = 15 * 1000; // 15s
export const TRACK_EVENT = "trackEvent";
export const TRACK_EVENT_SEARCH = "trackEventSearch";

export const SB_ENV = (brand: string, region: string): any => {
  switch (`${brand}${region}`) {
    case `${BRAND_LIST.UQ}${COUNTRY.AU}`:
      return UQAUCountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.CA}`:
      return UQCACountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.ID}`:
      return UQIDCountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.IN}`:
      return UQINCountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.MY}`:
      return UQMYCountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.SG}`:
      return UQSGCountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.PH}`:
      return UQPHCountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.TH}`:
      return UQTHCountryENV;
    case `${BRAND_LIST.UQ}${COUNTRY.VN}`:
      return UQVNCountryENV;
    default:
      return UQCACountryENV;
  }
};
